import React, { useState, useEffect ,useContext} from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AuthContext from '../../AuthContext'
import { ArrowLeftIcon } from '@heroicons/react/outline';
import axiosInstance from '../../axios'
import Image from './Image'
import NoImage from '../../assets/placeholder.jpg';

import {toast} from 'react-toastify'
import Pdf from '../../imageAxios'
const CentreDetails = () => {
  const navigate = useNavigate();
  const auth=useContext(AuthContext)
  const location = useLocation();
  const{id}=location.state||{}
  const centreId=(auth.userType==='Superadmin'||auth.userType==='Accounts'||auth.userType==='Manager')?id:auth.centre
  const [centre, setCentre] = useState({});
  const [images,setImages]=useState([])
  const[profile,setProfile]=useState('')
  const[document,setDocument]=useState('')
  const[agreement,setAgreement]=useState('')
  const[receipt,setReceipt]=useState('')
  const[cheque,setCheque]=useState('')
  useEffect(() => {
    axiosInstance.get(`/trainingcentre/get/${centreId}`)
      .then((res) => {
        setCentre(res.data);
        setProfile(res.data.cp_profile_image?`${Pdf}/${res.data.cp_profile_image}`:'')
        setDocument(res.data.documents?`${Pdf}/${res.data.documents}`:'')
        setAgreement(res.data.agreement_file?`${Pdf}/${res.data.agreement_file}`:'')
        setReceipt(res.data.receipt_file?`${Pdf}/${res.data.receipt_file}`:'')
        setCheque(res.data.cheque_file?`${Pdf}/${res.data.cheque_file}`:'')
        const imageData = res.data.centre_images;
        
        let imageArray = [];
      
        try {
          imageArray = JSON.parse(imageData);
        } catch (error) {
          console.error('Failed to parse image data:', error);
        }

        setImages(imageArray);
      })
      .catch((error) => {
        toast.error('Error fetching centre data:', error);
      });
  }, [id]);
  const handleView = (url) => {
    if (url) {
      window.open(url, '_blank');
    } else {
      alert('Document not found');
    }
  };
  const handleError = () => {
    setProfile(NoImage); // Path to your fallback image
  };
  return (
    <div className="col-span-12 lg:col-span-10  flex justify-center ">
    <div className=" flex flex-col gap-5  w-11/12">
      <div className="w-full max-w-4xl bg-white rounded-lg shadow-lg  overflow-hidden">
        <div className="flex items-center justify-between bg-gray-100 p-4 border-b border-gray-400">
          <div className="flex items-center space-x-2">
            <ArrowLeftIcon
              className="w-6 h-6 text-gray-600 cursor-pointer hover:text-gray-800 transition"
              onClick={() => navigate('/centre')}
            />
            <h1 className="md:text-xl text-md font-semibold text-gray-700">Centre Details :</h1>
            <p className='md:text-xl  text-md font-semibold text-gray-700'> VTP No :-&nbsp;{centre.vtp_id}</p>
          </div>
        </div>
        <div className="p-5">
        {auth.userType === 'Admin' && (
  <p className="bg-red-100 p-2 mt-0 text-red-800 text-sm h-full ">
    Note: In case you want to change any details, please contact MSSDS admin at info@mssds.in
  </p>
)}          <div className="grid grid-cols-2 md:grid-cols-3  gap-6">
           
{images&&<Image images={images}/>
}           
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Centre Name</div>
              <div className="text-gray-600">{centre.centre_name}</div>
            </div>
           
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">SIP ID</div>
              <div className="text-gray-600">{centre.vtp_no}</div>
            </div>
           
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">VTP ID</div>
              <div className="text-gray-600">{centre.vtp_id}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Category</div>
              <div className="text-gray-600">{centre.centre_category}</div>
            </div>

            
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Centre Address</div>
              <div className="text-gray-600">{centre.centre_address}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Pincode</div>
              <div className="text-gray-600">{centre.pin_code}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Tahsil</div>
              <div className="text-gray-600">{centre.tahsil}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Pan no.</div>
              <div className="text-gray-600">{centre.pan_no}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Tan no.</div>
              <div className="text-gray-600">{centre.tan_no}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Partner Agency</div>
              <div className="text-gray-600">{centre.pmkvy_partner}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">City</div>
              <div className="text-gray-600">{centre.city}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">State</div>
              <div className="text-gray-600">{centre.state}</div>
            </div>
            <div className="flex flex-col">
    <div className="text-gray-800 font-bold">Agreement</div>
    <div className="text-gray-600">
      {agreement ? (
        <button
          onClick={() => handleView(agreement)}
          className="text-blue-500 hover:underline"
        >
          View Agreement
        </button>
      ) : (
        'N/A'
      )}
    </div>
  </div>
  <div className="flex flex-col">
    <div className="text-gray-800 font-bold">Documents</div>
    <div className="text-gray-600">
      {document ? (
        <button
          onClick={() => handleView(document)}
          className="text-blue-500 hover:underline"
        >
          View Documents
        </button>
      ) : (
        'N/A'
      )}
    </div>
  </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Batch names</div>
              <div className="text-gray-600">{centre.batch_names}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Scheme names</div>
              <div className="text-gray-600">{centre.scheme_names}</div>
            </div>
            <div className="flex flex-col md:col-span-3 col-span-2">
              <p className='w-full bg-slate-600 p-1'></p>
              <p className="text-slate-800 font-bold text-xl text-centre">Contact Person Details</p>
            </div>
            <div className="flex flex-col ">
            <div className="text-gray-800 font-bold">Profile Picture
                <img
                  className="w-24 h-24 rounded-full object-cover"
                  src={profile}
                  onError={handleError}
                  alt="Contact Person Profile"
                 />
                
              </div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Full Name</div>
              <div className="text-gray-600">{centre.cp_name}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold"> Mobile No.</div>
              <div className="text-gray-600">{centre.cp_mo_no}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold"> Address</div>
              <div className="text-gray-600">{centre.cp_address}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Email</div>
              <div className="text-gray-600">{centre.cp_email}</div>
            </div>
            <div className="flex flex-col md:col-span-3 col-span-2">
              <p className='w-full bg-slate-600 p-1'></p>
              <p className="text-slate-800 font-bold text-xl text-centre">Bank Details</p>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Bank Name</div>
              <div className="text-gray-600">{centre.bank_name}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Bank IFSC Code</div>
              <div className="text-gray-600">{centre.ifsc_code}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Bank Account no.</div>
              <div className="text-gray-600">{centre.bank_acc_no}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Branch Name</div>
              <div className="text-gray-600">{centre.branch}</div>
            </div>
            

  <div className="flex flex-col">
    <div className="text-gray-800 font-bold"> Bank Receipt</div>
    <div className="text-gray-600">
      {receipt ? (
        <button
          onClick={() => handleView(receipt)}
          className="text-blue-500 hover:underline"
        >
          View Bank Receipt
        </button>
      ) : (
        'N/A'
      )}
    </div>
  </div>
  <div className="flex flex-col">
    <div className="text-gray-800 font-bold"> Cancelled Cheque</div>
    <div className="text-gray-600">
      {cheque ? (
        <button
          onClick={() => handleView(cheque)}
          className="text-blue-500 hover:underline"
        >
          View Cancelled Cheque
        </button>
      ) : (
        'N/A'
      )}
    </div>
  </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default CentreDetails;
